/**
 * Extrai a mensagem de erro do retorno da API
 * @param {Error} err - Objeto de erro do axios
 * @returns {string} - Mensagem de erro a ser exibida
 */
export const extrairMensagemErro = err => {
  // Se houver resposta do backend com dados de erro
  if (err?.response?.data) {
    const { data } = err.response;

    // Tenta extrair mensagem de diferentes estruturas possíveis
    if (data?.mensagem) {
      return data.mensagem;
    }

    if (data?.message) {
      return data.message;
    }

    if (data?.erro) {
      return data.erro;
    }

    if (data?.error) {
      return data.error;
    }

    // Se a resposta for uma string diretamente
    if (typeof data === 'string') {
      return data;
    }
  }

  // Se houver mensagem de erro padrão
  if (err?.message) {
    return err.message;
  }

  // Mensagem padrão caso nenhuma das anteriores existam
  return 'Ocorreu algum erro, favor entrar em contato com o suporte';
};

/**
 * Extrai o código de status do erro
 * @param {Error} err - Objeto de erro do axios
 * @returns {number|null} - Código de status HTTP ou null
 */
export const extrairCodigoStatus = err => err?.response?.status || null;

/**
 * Funciona que loga o erro completo para debug
 * @param {Error} err - Objeto de erro do axios
 * @param {string} context - Contexto onde o erro ocorreu (para identificar)
 */
export const logarErroDetalhado = (err, context = '') =>
  console.error(`[${context}]`, {
    status: extrairCodigoStatus(err),
    mensagem: extrairMensagemErro(err),
    erroCompleto: err
  });
